var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgVukSygnetGreen = function SvgVukSygnetGreen(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuk_sygnet_green_svg__final_color_v2",
    "data-name": "final_color v2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 565.3151 283.7931",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient",
    x1: 27.7082,
    y1: 223.1577,
    x2: 134.8092,
    y2: 182.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d66d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33c9b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-2",
    x1: 9.8572,
    y1: 228.302,
    x2: 103.2198,
    y2: 232.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31e09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fed80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-3",
    x1: 360.8156,
    y1: 270.9116,
    x2: 301.4749,
    y2: 164.0984,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-4",
    x1: 170.1014,
    y1: 261.3218,
    x2: 214.5565,
    y2: 194.6391,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-5",
    x1: 343.2486,
    y1: 242.2929,
    x2: 175.5343,
    y2: 244.45,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-6",
    x1: 419.3236,
    y1: 37.4407,
    x2: 367.8951,
    y2: 71.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-7",
    x1: 357.9103,
    y1: 64.9598,
    x2: 562.8993,
    y2: 64.9598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8771,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-8",
    x1: 510.8826,
    y1: 171.9648,
    x2: 535.41,
    y2: 124.4922,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-9",
    x1: 368.0952,
    y1: 275.4153,
    x2: 412.4029,
    y2: 152.7779,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-10",
    x1: 390.6458,
    y1: 235.5724,
    x2: 473.7227,
    y2: 256.935,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-11",
    x1: 575.7389,
    y1: 166.2122,
    x2: 324.1345,
    y2: 251.6627,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-12",
    x1: 175.455,
    y1: 59.2037,
    x2: 193.6528,
    y2: 92.4345,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-13",
    x1: 26.1273,
    y1: 118.9063,
    x2: 198.1127,
    y2: 33.5569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0614,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f5f5f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-14",
    x1: -9.3023,
    y1: 120.8548,
    x2: 35.5329,
    y2: 146.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuk_sygnet_green_svg__linear-gradient-15",
    x1: 283.1541,
    y1: 130.097,
    x2: 284.3232,
    y2: 55.273,
    xlinkHref: "#vuk_sygnet_green_svg__linear-gradient-6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172.4794,156.5021l-32.8701,67.53c-1.3477,2.0842-6.7676,9.9298-16.699,11.8855-1.063,.2093-4.5917,.8265-9,0-11.2234-2.1043-17.4888-11.5682-19-14-.6403-3.9285-1.2806-7.857-1.9209-11.7854l24.5-50.33,11.83-24.3,.5299,.26,42.6301,20.74Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6093,224.0321l-22.1299,45.47c-3.78,7.78-11.4601,12.92-20.0901,13.45-.5,.03-1,.05-1.49,.05-8.08,0-15.6599-4.07-20.11-10.9l-43-66,40.22-26.2,19.86,30.48,.1201-.25,7.7999,11.97c.5441,.8165,7.5151,10.8939,20.11,10.9,11.1567,.0054,17.8334-7.8959,18.71-8.97Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9103,238.9175c4.1611-1.2486,8.3223-2.4972,12.4835-3.7458l50.0349-101.5632-43.0586-21.2129-60.3992,122.6019c1.5029,1.958,3.4773,3.7072,5.9395,3.92,.5045,.0436,.8814,.0099,1,0,2.1906-.183,11.6906-.227,34,0Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.9103,240.9175c15.3375,5.1543,27.8689-5.4474,28.4082-5.92l44.1497-90.47-43.1377-21.0508-39.532,81.0083c-2.6294,6.1442-5.2588,12.2884-7.8882,18.4326,.5238,1.4963,5.007,13.6335,18,18Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4303,269.6075c-1.4601,2.5566-3.9467,6.7194-8.8525,9.77-3.735,2.3225-8.1074,3.62-12.6775,3.62h-90c-8.28,0-15.97-4.2599-20.36-11.28-4.38-7.02-4.84-15.8-1.21-23.24l21.47-44c-1.3245,2.1839-4.3815,7.9409-2.89,14.44,2.135,9.303,12.7809,16.6018,25.99,16.08h90c12.2573-3.3408,18.2886-8.7653,21.53-13.39,1.7596-2.5106,3.3718-5.748,3.48-5.69,.1676,.0899-4.0212,7.6923-8.1391,16.2088-5.1118,10.572-10.9677,24.5709-18.3409,37.4812Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.6743,38.1112c-7.4351,15.0955-14.8702,30.1909-22.3052,45.2864l43.0605,21.209c7.7706-15.5725,15.53-31.3403,23.2716-47.3031,7.2074-14.8613,14.2724-29.6299,21.1981-44.3014-21.7417,8.3697-43.4833,16.7394-65.225,25.1091Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.9103,12.9175c-21.6667,8.3333-43.3333,16.6667-65,25,18.8178,7.587,33.8618,14.5081,43.9942,19.3573,42.3037,20.2458,65.0202,36.1973,115.5108,57.4219l5.484,2.3053c10-5.3333,20-10.6667,30-16,3.3333-5.6667,6.6667-11.3333,10-17-46.663-23.6948-93.326-47.3897-139.989-71.0845Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.8993,84.0021c-15.121,11.084-30.242,22.168-45.363,33.252l.1296,.0644-28.3213,21.6006,29.1094,38.166,46.8611-35.7415c-.8052-19.1138-1.6105-38.2277-2.4158-57.3416Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.9103,241.9175c22.3333-17,44.6667-34,67-51,1.3274-2.1909,2.6548-4.3818,3.9822-6.5727l29.5898-60.8467-43.166-20.9922c-17.5993,35.7443-35.0679,71.5481-52.406,107.4116-6.2136,12.8527-12.4116,25.7156-18.594,38.5884,4.5313-2.1962,9.0627-4.3923,13.594-6.5884Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1761,251.4386c7.67,10.7808,15.413,21.5811,23.1837,32.3545h59.3105c-14.6282-20.0389-29.2607-40.3279-43.6456-60.5498-.0381-2.1086-.0764-4.2172-.1145-6.3257l-45,33,6.2659,1.5211Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.2403,196.2475l-2.43,1.8101-65.75,48.39c-2.29,1.66-4.59,3.32-6.88,4.99l-38.43,27.16c-8.94,6.33-21.04,5.79-29.39-1.3-8.31-7.07-9.82-18.94-6.88-26.87,.31-.83,.62-1.4901,.84-1.92,.31-.66,.63-1.31,.95-1.97l.7401-1.52c5.2131-10.8277,10.4265-21.6553,15.6398-32.4828l1.2601-2.6171s.0004-.0009,.0005-.0013c.0002-.0007,.0004-.0013,.0004-.0013-.0003-.0001-.7505,2.2509-2.0009,6.0026-.5225,3.074,.6265,6.1682,3,8,2.8257,2.1808,6.9226,2.2139,10,0,6.3251-4.323,10.9511-7.4968,11.2681-7.7297,.3358-.2468,.7422-.5457,.7422-.5457,1.2585-.9256,21.4617-15.7848,42.9196-31.5746,2.8439-2.0927,29.7369-21.8856,32.65-24.03l3.07-2.26,28.68,38.47Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8993,12.0021c-16.3334,31.6667-32.6666,63.3333-49,95,14.3334,7,28.6666,14,43,21,13.6703-27.3615,27.3407-54.723,41.011-82.0845-11.6703-11.3052-23.3407-22.6103-35.011-33.9154Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9103,11.9175c-57.6606,27.5524-115.3211,55.1049-172.9817,82.6573-.0098,3.4757-.0195,6.9515-.0293,10.4272,6.6666,10,13.3334,20,20,30,2.1914,.0298,4.3829,.0596,6.5743,.0894,36.4468-16.6033,73.6426-34.3153,111.4794-53.2187,23.8615-11.9213,47.1806-23.9181,69.9573-35.9552-11.6667-11.3333-23.3333-22.6667-35-34Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,152.6086l15.4926,25.0263,40.8135-25.2656-11.9111-19.2402c-8.4985-13.0423-16.9971-26.0847-25.4956-39.127-6.2998,19.5355-12.5995,39.071-18.8993,58.6065Z",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.5912 0 239.3446 94.4474 282.454 115.5568 329.2408 20.0063 285.5912 0",
    style: {
      fill: "url(#vuk_sygnet_green_svg__linear-gradient-15)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgVukSygnetGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vuk_sygnet_green.d5878611af6e2341035319fd047a173c.svg";